function validateClaimDayForm() {
    const form = document.querySelector('.js-claim-day-form');
    const mountainField = document.querySelector(
        '.js-claim-day-field-wrapper .js-select2'
    );
    const mountainSign = document.querySelector('.js-claim-day-mountain-sign');
    const dateField = document.querySelector('.js-claim-day-date-field');
    const dateSign = document.querySelector('.js-claim-day-date-sign');

    function validateMountain() {
        if ($(mountainField).val() == '') {
            showErrorMessage(mountainSign, 'Choose mountain');
            return false;
        }

        hideErrorMessage(mountainSign);
        return true;
    }

    function validateDate() {
        if ($(dateField).val() == '') {
            showErrorMessage(dateSign, 'Choose date');
            return false;
        }

        hideErrorMessage(dateSign);
        return true;
    }

    $(form).submit(function (e) {
        e.preventDefault();

        if (validateMountain() && validateDate()) {
            $(this)
                .off('submit')
                .on('submit', function () {
                    return true;
                });
            $(this)[0].submit();
        } else {
            console.log('Validation failed');
        }
    });
}

runIfElementExist(validateClaimDayForm, '.js-claim-day-form');
